import { render, staticRenderFns } from "./payFlowList.vue?vue&type=template&id=9606830e&scoped=true"
import script from "./payFlowList.vue?vue&type=script&lang=js"
export * from "./payFlowList.vue?vue&type=script&lang=js"
import style0 from "./payFlowList.vue?vue&type=style&index=0&id=9606830e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9606830e",
  null
  
)

export default component.exports